import { render, staticRenderFns } from "./BillingTermForm.vue?vue&type=template&id=c5d46cb8"
import script from "./BillingTermForm.vue?vue&type=script&lang=js"
export * from "./BillingTermForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports